// Axios and config
import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"

// Interfaces and constants
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import { I_VehicleSafetyEventsReference } from "../interfaces"
import vehicleSafetyEventsReferenceBoilerplate from "../constants/VehicleSafetyEventsReferenceBoilerplate"

// UI utilities
import snackBar from "src/utilities/snackBar/SnackBar"

/**
 * Fetches vehicle safety event reference data from the API.
 * Falls back to a boilerplate/default reference object if the request fails.
 */
const getVehicleSafetyEventsReference = async (): Promise<I_VehicleSafetyEventsReference> => {
  try {
    const response = await Axios.get<I_BaseAPIResponse<I_VehicleSafetyEventsReference>>(
      `${process.env.REACT_APP_API_URL}/api/samsara/getVehicleSafetyEventsReference`,
      AxiosConfig.configValue()
    )

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage)

      snackBar({
        type: "error",
        text: "Failed to reference data",
        timeout: 5000,
      })

      return vehicleSafetyEventsReferenceBoilerplate
    }

    return response.data.Data
  } catch (error) {
    console.error("Network or parsing error:", error)

    snackBar({
      type: "error",
      text: "Failed to reference data",
      timeout: 5000,
    })

    return vehicleSafetyEventsReferenceBoilerplate
  }
}

export default getVehicleSafetyEventsReference
